import { List } from 'immutable';
import { lruMemoize } from 'reselect';

import {
    isResourceLoading,
    getResourceTotal,
    getResourcePage,
    getResourcePerPage,
} from './common';

const isHomeArticlesLoading = lruMemoize(isResourceLoading);
const getHomeArticlesTotal = getResourceTotal;
const getHomeArticlesPage = getResourcePage;
const getHomeArticlesPerPage = getResourcePerPage;
const getHomeArticles = lruMemoize(
    (data) => data.get('home_articles', List()),
);

export {
    isHomeArticlesLoading,
    getHomeArticlesTotal,
    getHomeArticlesPage,
    getHomeArticlesPerPage,
    getHomeArticles,
};
